/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import MainPagesLayout from '@/src/layout/MainPagesLayout/MainPagesLayout';

import { IRoutes } from 'src/types/router';

import routes from 'src/config/routerConfig/mainPages';

const route: IRoutes = {
  layout: MainPagesLayout,
  subRoutes: routes,
};
export default route;
